export const downloadAsJsonFile = (
  data: BlobPart[],
  downloadFileName: string
) => {
  const blob = new Blob(data, {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${downloadFileName}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
